import React from "react";
import { REVIEW_TASK_STATUS } from "../../constants/reviewConstants";
import "./FieldClarificationDecorator.css";

const FieldClarificationDecorator = ({
  task,
  isSelected = false,
  className = "",
  children,
}) => {
  if (!task) {
    return children;
  }

  const isCompleted = task?.status === REVIEW_TASK_STATUS.COMPLETED;
  const note = task?.remark?.trim();

  return (
    <div
      className={`fv_field_review ${className} ${isCompleted ? "fv_field_review--complete" : "fv_field_review--pending"} ${isSelected ? "fv_field_review--selected" : ""}`.trim()}
      data-review-field-id={task?.fieldId}
    >
      <div className="fv_field_review__content">{children}</div>
      {note ? (
        <div className="fv_field_review__note">
          <span className="fv_field_review__note_text">{note}</span>
        </div>
      ) : null}
    </div>
  );
};

export default FieldClarificationDecorator;
